export default __webpack_public_path__ + "static/media/pdf.3fce4ea7.png";